var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoWheeler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C19.82 11 19.64 11.03 19.47 11.05L17.41 9H19C19.55 9 20 8.55 20 8V7.62C20 6.88 19.22 6.39 18.55 6.73L16.27 7.87L13.7 5.3C13.52 5.11 13.26 5 13 5H10C9.45 5 9 5.45 9 6C9 6.55 9.45 7 10 7H12.17C12.44 7 12.69 7.11 12.88 7.29L14.59 9H11.24C11.08 9 10.93 9.04 10.79 9.11L7.65 10.68C7.27 10.87 6.8 10.8 6.5 10.49L5.3 9.29C5.11 9.11 4.85 9 4.59 9H1C0.45 9 0 9.45 0 10C0 10.55 0.45 11 1 11H4C1.48 11 -0.49 13.32 0.11 15.94C0.44 17.39 1.61 18.56 3.06 18.89C5.68 19.49 8 17.52 8 15L9.41 16.41C9.79 16.79 10.3 17 10.83 17H11.84C12.56 17 13.22 16.62 13.58 15.99L16.49 10.9L17.5 11.91C16.37 12.82 15.74 14.32 16.12 15.96C16.46 17.4 17.63 18.57 19.07 18.9C21.68 19.49 24 17.51 24 15C24 12.79 22.21 11 20 11ZM4 17C2.9 17 2 16.1 2 15C2 13.9 2.9 13 4 13C5.1 13 6 13.9 6 15C6 16.1 5.1 17 4 17ZM20 17C18.9 17 18 16.1 18 15C18 13.9 18.9 13 20 13C21.1 13 22 13.9 22 15C22 16.1 21.1 17 20 17Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoWheeler);
export default __webpack_public_path__ + "static/media/two-wheeler.fb7d1e775ec68e2c100a236d894077d2.svg";
export { ForwardRef as ReactComponent };